import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "./styles.css";
import { faArrowLeft, faTimes } from "@fortawesome/free-solid-svg-icons";

const SideContainer = ({ title, children, onClose, configs = [], className }) => {
  return (
    <div
      className="side__container--wrapper"
      onClick={(event) => {
        const targetEl = event.target;

        if (targetEl.closest(".side__container")) return;

        if (onClose) onClose();
      }}
    >
      <div className={`side__container ${className}`}>
        <div className="side__container--header">
          <div className="side__container--header-icon" onClick={() => onClose()}>
            <FontAwesomeIcon icon={faArrowLeft} />
          </div>
          <div className="side__container--header-text">
            <span>{title}</span>

            <div className="side__container--configs">
              {configs.map(item => (
                <div className="side__container--config-item" onClick={item.onClick} title={item.tooltip}>
                  <FontAwesomeIcon icon={item.icon} />
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className="side__container--body">
          {children}
        </div>
      </div>
    </div>
  )
}

export default SideContainer;